import {
  useState,
  useEffect,
} from 'react';
import { Message } from '@oneflowab/pomes';
import clsx from 'clsx';

import DustSwoosh from './dust-swoosh.gif';

import style from './extraction-loading-state.module.scss';

const extractionLoadingMessages = [
  <Message
    key="boxes"
    id="duration"
    comment="Message that shows in the loading state, follows the word 'Extracting'"
  />,
  <Message
    key="parties"
    id="parties"
    comment="Message that shows in the loading state, follows the word 'Extracting'"
  />,
  <Message
    key="closeTime"
    id="sign date"
    comment="Message that shows in the loading state, follows the word 'Extracting'"
  />,
  <Message
    key="participants"
    id="participants"
    comment="Message that shows in the loading state, follows the word 'Extracting'"
  />,
];

export const ExtractionLoadingState = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFadingOut(true);
      setTimeout(() => {
        setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % extractionLoadingMessages.length);
        setIsFadingOut(false);
      }, 500);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={style.ExtractionLoadingWrapper}>
      <img src={DustSwoosh} height="118px" width="270px" alt="" aria-hidden="true" />
      <div className={style.TextWrapper}>
        <Message
          id="Extracting {extractedProperty}"
          comment="Prefix text used before the property that is being extracted with AI. Examples: Extracting duration, Extracting participants"
          values={{
            extractedProperty: (
              <span
                className={clsx(style.AnimatedText, {
                  [style.FadeOut]: isFadingOut,
                })}
              >
                {extractionLoadingMessages[currentMessageIndex]}
                ...
              </span>
            ),
          }}
        />
      </div>
    </div>
  );
};
